// Tipos de defeitos para consertos e ajustes
export const TIPOS_DEFEITO = [
  { value: "costura_rompida", label: "Costura rompida" },
  { value: "furo", label: "Furo/Rasgão" },
  { value: "mancha", label: "Mancha" },
  { value: "alongar", label: "Alongar" },
  { value: "encurtar", label: "Encurtar" },
  { value: "ajuste_cintura", label: "Ajuste de cintura" },
  { value: "ajuste_manga", label: "Ajuste de manga" },
  { value: "ajuste_gola", label: "Ajuste de gola" },
  { value: "remendo", label: "Remendo/Reforço" },
  { value: "ziper", label: "Problemas com zíper" },
  { value: "botao", label: "Botão solto/faltando" },
  { value: "pintura", label: "Pintura/Tinta" },
  { value: "oxidacao", label: "Oxidação/Ferrugem" },
  { value: "desbotado", label: "Desbotado" },
  { value: "outro", label: "Outro" },
];

export const NIVEIS_DIFICULDADE = [
  { value: "simples", label: "Simples (< 2 horas)", diasPadrao: 2 },
  { value: "medio", label: "Médio (2-6 horas)", diasPadrao: 5 },
  { value: "complexo", label: "Complexo (> 6 horas)", diasPadrao: 10 },
];

export const LOCAIS_PROVA = [
  { value: "atelier", label: "No atelier" },
  { value: "cliente", label: "Casa do cliente" },
  { value: "video", label: "Vídeo chamada" },
  { value: "email", label: "Por email/foto" },
];

// Configuração de prazos padrão por tipo de pedido
export const PRAZO_PADRAO_DIAS: Record<string, number> = {
  conserto_simples: 2,
  conserto_medio: 5,
  conserto_complexo: 10,
  ajuste: 3,
  bordado: 7,
  camiseta: 5,
  uniforme: 7,
  personalizado: 10,
  catalogo: 3,
};

// Campos específicos para consertos
export interface ConsertoDados {
  ehConserto: boolean;
  materialCliente: boolean;
  tipoDefeito: string;
  descricaoDefeito: string;
  areiaAfetada: string;
  nivelDificuldade: string;
  dataEntrada: string;
  observacoes: string;
}
